<template>
  <div>
    <router-view />
  </div>
</template>
<script>

export default {
  name: "GerbangTolIndex",
  data () {
    return {}
  },
  created () {

  },
  methods: {
  
  },
}

</script>
